<template>
  <div :class="['hos-dial', { 'is-low': isLow }]">
    <div>
      <div class="hos-dial-time">{{ time }}</div>
      <div class="hos-dial-label" :style="{ color }">
        <span class="hos-dial-dot"></span>
        <span :style="{ color: 'var(--text-muted)' }">{{ label }}</span>
      </div>
    </div>

    <svg class="hos-dial-ring" viewBox="0 0 36 36" aria-hidden="true">
      <!-- r = 15.9155 gives a circumference of exactly 100, so the dash array
           can be written directly as a percentage. -->
      <circle class="track" cx="18" cy="18" r="15.9155" fill="none" stroke-width="3.2" />
      <circle
          class="arc"
          cx="18" cy="18" r="15.9155"
          fill="none"
          stroke-width="3.2"
          :stroke-linecap="filled > 0 ? 'round' : 'butt'"
          :stroke="isLow ? 'var(--warn)' : color"
          :stroke-dasharray="`${filled} ${100 - filled}`"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'HosDial',
  props: {
    label: { type: String, required: true },
    /** Formatted remaining time, HH:MM. */
    time: { type: String, default: '—' },
    /** Share of the clock still remaining, 0-100. */
    progress: { type: Number, default: 0 },
    /** Whole minutes remaining, used to flag the last hour. */
    minutesLeft: { type: Number, default: null },
    color: { type: String, required: true },
  },
  computed: {
    filled() {
      const value = Number(this.progress)
      if (!Number.isFinite(value)) return 0
      return Math.min(Math.max(value, 0), 100)
    },
    /** The last hour of a clock is the moment a dispatcher is watching for. */
    isLow() {
      return this.minutesLeft !== null && this.minutesLeft > 0 && this.minutesLeft < 60
    },
  },
}
</script>

<style scoped>
@import './TruckList.css';
</style>
